import { Slide } from '@mui/material'
import cn from 'classnames'
import Pill from 'ext-ui/components/Pill/Pill'
import Tooltip from 'ext-ui/components/Tooltip/Tooltip'
import { Location } from 'history'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import HoverableLink from 'src/components/HoverableLink/HoverableLink'
import SidenavSelectedBar from 'src/components/SidenavSelectedBar/SidenavSelectedBar'
import { SupportedBrands } from 'src/enums'
import { useHasSaasEntitlement } from 'src/hooks/useHasSaasEntitlement'
import { useTranslate } from 'src/localization/Trns'
import { getSaasTierLabel } from 'src/models/organizations.models'
import { UserFeature } from 'src/models/user.models'
import { LocationState } from 'src/redux/createRootReducer'
import { selectBrandName } from 'src/redux/selectors/session.selectors'

import style from './SidenavContentExpandedItemLink.style'

export interface SidenavContentExpandedItemLinkProps {
  id: string
  isActive: boolean
  isOpen: boolean
  label: string
  to?: string | Location<LocationState>
  feature?: UserFeature
}

const SidenavContentExpandedItemLink: React.FC<
  SidenavContentExpandedItemLinkProps
> = (props): React.ReactElement => {
  const translate = useTranslate()
  const [hover, setHover] = useState<boolean>(false)
  const labelTextRef = React.useRef<HTMLDivElement>(null)
  const isJPM = useSelector(selectBrandName) === SupportedBrands.Jpm

  const { upgradeRequired, requiredTier } = useHasSaasEntitlement({
    feature: props.feature,
  })

  const overflowing =
    labelTextRef.current &&
    labelTextRef.current.scrollWidth > labelTextRef.current.clientWidth

  return (
    <div id={props.id} data-testid={props.id} css={style}>
      <Slide in={props.isActive} direction={'right'} mountOnEnter unmountOnExit>
        <SidenavSelectedBar />
      </Slide>
      <Tooltip
        tooltipContent={overflowing ? props.label : undefined}
        placement={'right'}
        enterDelay={0}
      >
        <div
          className={cn('sidenav-link', {
            open: props.isOpen,
            closed: !props.isOpen,
            hover: hover,
            active: props.isActive,
            jpm: isJPM,
          })}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          <HoverableLink
            className="sidenav-label"
            ariaLabel={props.label}
            to={props.to}
          >
            <div ref={labelTextRef} className="sidenav-label-text">
              {props.label}
            </div>
            {props.feature && requiredTier && upgradeRequired && (
              <Pill
                size="small"
                color={props.isActive || hover ? undefined : 'saas'}
                className="sidenav-pill"
              >
                {translate(getSaasTierLabel(requiredTier))}
              </Pill>
            )}
          </HoverableLink>
        </div>
      </Tooltip>
    </div>
  )
}

export default SidenavContentExpandedItemLink
